import React from "react";
import { Footer, Navbar } from "../components";
import { useSelector, useDispatch } from "react-redux";
import { addCart, delCart } from "../redux/action";
import { useCurrency } from "../context/CurrencyContext";
import { Link } from "react-router-dom";
import { WHATSAPP_PHONE } from "../config";
import { toAnalyticsItem, trackEvent } from "../lib/analytics";

const Cart = () => {
  const state = useSelector((state) => state.handleCart);
  const dispatch = useDispatch();
  const { currency, formatPrice } = useCurrency();

  const EmptyCart = () => {
    return (
      <div className="container">
        <div className="row">
          <div className="col-md-12 py-5 bg-light text-center">
            <h4 className="p-3 display-5">Tu carrito esta vacio</h4>
            <Link to="/" className="btn btn-outline-dark mx-4">
              <i className="fa fa-arrow-left"></i> Seguir comprando
            </Link>
          </div>
        </div>
      </div>
    );
  };

  const addItem = (product) => {
    trackEvent("add_to_cart", {
      currency,
      value: Number(product.price || 0),
      items: [toAnalyticsItem(product, 1)],
    });
    dispatch(addCart(product));
  };

  const removeItem = (product) => {
    trackEvent("remove_from_cart", {
      currency,
      value: Number(product.price || 0),
      items: [toAnalyticsItem(product, 1)],
    });
    dispatch(delCart(product));
  };

  const ShowCart = () => {
    let subtotal = 0;
    let shipping = 0.0;
    let totalItems = 0;
    state.map((item) => {
      return (subtotal += item.price * item.qty);
    });

    state.map((item) => {
      return (totalItems += item.qty);
    });

    const pageUrl = typeof window !== "undefined" ? window.location.href : "";
    const whatsappMessage = [
      "A1 Pro - Nuevo pedido",
      "",
      "Resumen:",
      ...state.map((item) => `- ${item.title} x${item.qty} (${formatPrice(item.price)})`),
      "",
      `Total productos: ${totalItems}`,
      `Moneda: ${currency}`,
      `Total: ${formatPrice(subtotal)}`,
      `URL: ${pageUrl}`,
    ].join("\n");
    const whatsappUrl = `https://api.whatsapp.com/send?phone=${WHATSAPP_PHONE}&text=${encodeURIComponent(
      whatsappMessage
    )}`;
    const checkoutPayload = {
      currency,
      value: Number(subtotal + shipping || 0),
      items: state.map((item) => toAnalyticsItem(item, item.qty)),
      item_count: Number(totalItems || 0),
    };

    return (
      <>
        <section className="h-100 gradient-custom">
          <div className="container py-5">
            <div className="row d-flex justify-content-center my-4">
              <div className="col-md-8">
                <div className="card mb-4">
                  <div className="card-header py-3">
                    <h5 className="mb-0">Lista de programas</h5>
                  </div>
                  <div className="card-body">
                    {state.map((item) => {
                      return (
                        <div key={item.id}>
                          <div className="row d-flex align-items-center">
                            <div className="col-lg-3 col-md-12">
                              <div className="bg-image rounded" data-mdb-ripple-color="light">
                                <img src={item.image} alt={item.title} width={100} height={75} />
                              </div>
                            </div>

                            <div className="col-lg-5 col-md-6">
                              <p>
                                <strong>{item.title}</strong>
                              </p>
                            </div>

                            <div className="col-lg-4 col-md-6">
                              <div className="d-flex mb-4" style={{ maxWidth: "300px" }}>
                                <button
                                  className="btn px-3"
                                  onClick={() => {
                                    removeItem(item);
                                  }}
                                >
                                  <i className="fas fa-minus"></i>
                                </button>

                                <p className="mx-5">{item.qty}</p>

                                <button
                                  className="btn px-3"
                                  onClick={() => {
                                    addItem(item);
                                  }}
                                >
                                  <i className="fas fa-plus"></i>
                                </button>
                              </div>

                              <p className="text-start text-md-center">
                                <strong>
                                  <span className="text-muted">{item.qty}</span> x {formatPrice(item.price)}
                                </strong>
                              </p>
                            </div>
                          </div>

                          <hr className="my-4" />
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card mb-4">
                  <div className="card-header py-3 bg-light">
                    <h5 className="mb-0">Resumen de compra</h5>
                  </div>
                  <div className="card-body">
                    <ul className="list-group list-group-flush">
                      <li className="list-group-item d-flex justify-content-between align-items-center border-0 px-0 pb-0">
                        Programas ({totalItems})<span>{formatPrice(subtotal)}</span>
                      </li>
                      <li className="list-group-item d-flex justify-content-between align-items-center px-0">
                        Acceso digital
                        <span>{formatPrice(shipping)}</span>
                      </li>
                      <li className="list-group-item d-flex justify-content-between align-items-center border-0 px-0 mb-3">
                        <div>
                          <strong>Total</strong>
                        </div>
                        <span>
                          <strong>{formatPrice(subtotal + shipping)}</strong>
                        </span>
                      </li>
                    </ul>

                    <Link
                      to="/checkout"
                      className="btn btn-dark btn-lg btn-block"
                      onClick={() => trackEvent("begin_checkout", checkoutPayload)}
                    >
                      Ir a pagar
                    </Link>
                    <a
                      href={whatsappUrl}
                      className="btn btn-whatsapp btn-lg btn-block mt-2"
                      onClick={() =>
                        trackEvent("whatsapp_checkout", {
                          ...checkoutPayload,
                          source: "cart_page",
                        })
                      }
                      target="_blank"
                      rel="noreferrer"
                    >
                      Finalizar por WhatsApp
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    );
  };

  return (
    <>
      <Navbar />
      <div className="container my-3 py-3">
        <h1 className="text-center" data-aos="fade-up">
          Carrito
        </h1>
        <hr />
        {state.length > 0 ? <ShowCart /> : <EmptyCart />}
      </div>
      <Footer />
    </>
  );
};

export default Cart;
